import { render, staticRenderFns } from "./RewardManagement.vue?vue&type=template&id=57dc8f96"
import script from "./reward-management.ts?vue&type=script&lang=ts&external"
export * from "./reward-management.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports